import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CACHE_KEYS } from "../../services/local/CacheManager";

interface LanguageState {
    lang: string;
}

const initialState: LanguageState = {
    lang: localStorage.getItem(CACHE_KEYS.LANGUAGE) || "en",
};

const languageSlice = createSlice({
    name: "language",
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<string>) => {
            state.lang = action.payload;
            localStorage.setItem(CACHE_KEYS.LANGUAGE, action.payload);
        },
    },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
